// extracted by mini-css-extract-plugin
export default {"contactForm":"IletisimFormu_contactForm__Wr20C","sendButton":"IletisimFormu_sendButton__UnlDr"};